
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/no-delivery",
      function () {
        return require("private-next-pages/no-delivery/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/no-delivery"])
      });
    }
  